import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserProfile } from '@/api/types/auth.types';

interface AuthState {
  user: UserProfile | null;
  isAuthenticated: boolean;
  setUser: (user: UserProfile) => void;
  clearUser: () => void;
  updateMessageBalance: (messages: number) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      
      setUser: (user) => set({ user, isAuthenticated: true }),
      
      clearUser: () => set({ user: null, isAuthenticated: false }),
      
      updateMessageBalance: (messages) =>
        set((state) =>
          state.user
            ? {
                user: {
                  ...state.user,
                  messages,
                  remainingMessages: messages,
                },
              }
            : state
        ),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
